import React from 'react'
import { useTranslation } from 'react-i18next'
import sarIcon from '../../assets/images/SAR.svg'
import { useCountryConfig } from '../../hooks/useCountryConfig'
import { isEgyptCountry } from '../../utils/currencyUtils'

interface CurrencyDisplayProps {
  className?: string
  alt?: string
  iconStyle?: React.CSSProperties
}

/**
 * Currency renderer driven by Settings (via CountryConfig).
 * - Egypt (EG / EGP): localized text ج.م / EGP — never the Saudi SVG.
 * - All other / unset (incl. Saudi SAR): existing Saudi Riyal SVG (pixel-identical).
 */
const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  className = 'w-4 h-4',
  alt = 'SAR',
  iconStyle,
}) => {
  const countryConfig = useCountryConfig()
  const { t } = useTranslation()

  if (isEgyptCountry(countryConfig)) {
    return (
      <span className={className} style={{ display: 'inline-block' }}>
        {t('currency.egyptSymbol')}
      </span>
    )
  }

  return (
    <img
      src={sarIcon}
      alt={alt}
      className={className}
      style={iconStyle}
    />
  )
}

export default CurrencyDisplay
